export var PaymentMethodType = /*#__PURE__*/function (PaymentMethodType) {
  PaymentMethodType["CREDITCARD"] = "CREDITCARD";
  PaymentMethodType["PAYPAL"] = "PAYPAL";
  PaymentMethodType["DROPIN"] = "DROPIN";
  PaymentMethodType["IAPAPPLE"] = "IAPAPPLE";
  PaymentMethodType["APPLEPAY"] = "APPLEPAY";
  PaymentMethodType["GOOGLEPAY"] = "GOOGLEPAY";
  PaymentMethodType["CASHAPP"] = "CASHAPP";
  return PaymentMethodType;
}(PaymentMethodType || {});
export var PaymentMethodStatus = /*#__PURE__*/function (PaymentMethodStatus) {
  PaymentMethodStatus["active"] = "active";
  PaymentMethodStatus["expired"] = "expired";
  PaymentMethodStatus["expiringSoon"] = "expiringSoon";
  return PaymentMethodStatus;
}(PaymentMethodStatus || {});
/*
  Apple Pay, Google Pay, and Venmo are pre-authenticated payment methods. This means they don't undergo 3DS verification.
  Additionally, these payment methods aren't automatically vaulted. Therefore, we must use the nonce to vault them rather than authenticating the transaction.
**/
export const preAuthenticatedPaymentMethodTypes = [PaymentMethodType.APPLEPAY, PaymentMethodType.GOOGLEPAY, PaymentMethodType.DROPIN];